import React, { createContext, useContext, useState, useCallback } from 'react';
import { BLOG_EN, BLOG_FI } from '../lib/blogPaths';

const DEFAULT_FI_URL = BLOG_FI;
const DEFAULT_EN_URL = BLOG_EN;

const LanguageSwitcherContext = createContext({
  fiUrl: DEFAULT_FI_URL,
  enUrl: DEFAULT_EN_URL,
  setLanguageSwitcherUrls: () => {},
});

export function LanguageSwitcherProvider({ children }) {
  const [urls, setUrls] = useState({ fiUrl: DEFAULT_FI_URL, enUrl: DEFAULT_EN_URL });
  const setLanguageSwitcherUrls = useCallback(({ fiUrl, enUrl } = {}) => {
    setUrls({
      fiUrl: fiUrl ?? DEFAULT_FI_URL,
      enUrl: enUrl ?? DEFAULT_EN_URL,
    });
  }, []);
  return (
    <LanguageSwitcherContext.Provider
      value={{
        fiUrl: urls.fiUrl,
        enUrl: urls.enUrl,
        setLanguageSwitcherUrls,
      }}
    >
      {children}
    </LanguageSwitcherContext.Provider>
  );
}

export function useLanguageSwitcher() {
  const context = useContext(LanguageSwitcherContext);
  if (!context) {
    return {
      fiUrl: DEFAULT_FI_URL,
      enUrl: DEFAULT_EN_URL,
      setLanguageSwitcherUrls: () => {},
    };
  }
  return context;
}
